import { render, staticRenderFns } from "./YoutubeVideos.vue?vue&type=template&id=0765f972&scoped=true"
import script from "./YoutubeVideos.vue?vue&type=script&lang=js"
export * from "./YoutubeVideos.vue?vue&type=script&lang=js"
import style0 from "./YoutubeVideos.vue?vue&type=style&index=0&id=0765f972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765f972",
  null
  
)

export default component.exports